import React, { Fragment, useState } from 'react'
import styled from 'styled-components'
import ErrorBoundary from 'components/errorBoundary'
import { Typography } from 'components'
import VideoModal from './VideoModal'
import getImageUrl from 'utils/getImageUrl'
import { useWindowSize } from 'react-use'
import { ReactComponent as VideoIcon } from 'images/icons/VideoCamera.svg'
import { ReactComponent as FileIcon } from 'images/icons/Paragraph.svg'
import { ReactComponent as PlayIcon } from 'images/icons/icon-play.svg'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;

  @media (max-width: 720px) {
    margin-top: 0;
  }
  @media (max-width: 425px) {
    margin-top: 15px;
  }
`
const ItemContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  // align-items: flex-start;
  align-items: center;
  justify-content: space-between;
  gap: 15px;

  @media (max-width: 425px) {
    gap: 10px;
  }
`
const NameGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  // align-items: flex-start;
  align-items: center;
  gap: 15px;

  @media (max-width: 425px) {
    gap: 10px;
  }
`
const IconBox = styled.div`
  max-width: 50px;
  max-height: 50px;
  width: 50px;
  height: 50px;
  min-width: 50px;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ hasVideo }) => (hasVideo ? '0' : '0 0px')};

  @media (max-width: 425px) {
    max-width: 25px;
    max-height: 25px;
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
  }
  @media (max-width: 300px) {
    max-width: 25px;
    max-height: 25px;
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
  }
`
const VideoWrapper = styled.div`
  width: 192px;
  height: 108px;

  @media (max-width: 768px) {
    width: 160px;
    height: 90px;
  }
  @media (max-width: 640px) {
    width: 128px;
    height: 72px;
  }
  @media (max-width: 512px) {
    width: 96px;
    height: 54px;
  }
`
const VideoBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-image: ${({ coverImage }) => `url(${coverImage})`};
  background-size: cover;
  background-repeat: no-repeat;
  border: 2px solid white;
`

const coverSize = {
  width: 240,
  height: 135,
}

const Item = ({ data, courseImage }) => {
  const [openModal, setOpenModal] = useState(false)
  const { width } = useWindowSize()
  const hasVideo = Boolean(data?.videoLink)
  const hasPreview = Boolean(data?.preview?.url)

  const getImage = () => {
    if (data?.preview?.image) {
      return data.preview.image
    }
    if (data?.coverImageVideo) {
      return data.coverImageVideo
    }
    if (courseImage) {
      return courseImage
    }
    return ''
  }

  const coverImage = getImageUrl(
    getImage(),
    'https://via.placeholder.com/300/FFFFFF/FFFFFF',
    coverSize.width,
    coverSize.height
  )

  const onClickVideo = () => {
    setOpenModal(true)
  }

  return (
    <Fragment>
      <ItemContainer>
        <NameGroup>
          <IconBox hasVideo={hasVideo}>
            {hasVideo ? (
              <VideoIcon width={'100%'} height={'100%'} />
            ) : (
              <FileIcon width={'100%'} height={'100%'} />
            )}
          </IconBox>
          <div>
            <Typography
              color="primary1"
              fontSize={width <= 425 ? 'text-xs' : 'text-sm'}
              fontWeight={600}
              numberOfLines={1}
            >
              {data?.name}
            </Typography>
            {/* <Typography
              fontSize={width <= 425 ? 'text-xs' : 'text-sm'}
              fontWeight={600}
              numberOfLines={2}
              style={{ color: 'rgba(255, 255, 255, 0.7)' }}
            >
              {data?.description}
            </Typography> */}
          </div>
        </NameGroup>
        <VideoWrapper>
          {hasPreview && (
            <VideoBox coverImage={coverImage} onClick={onClickVideo}>
              <PlayIcon width={50} height={50} />
            </VideoBox>
          )}
        </VideoWrapper>
      </ItemContainer>
      <VideoModal isOpen={openModal} setOpenModal={setOpenModal} videoUrl={data?.preview?.url} />
    </Fragment>
  )
}

const LectureTab = ({ lectures = [], courseImage }) => {
  // console.log('lectures', lectures)

  if (lectures.length <= 0) {
    return null
  }
  return (
    <ErrorBoundary>
      <Container>
        {lectures.map((item, index) => {
          return <Item key={index} data={item} courseImage={courseImage} />
        })}
      </Container>
    </ErrorBoundary>
  )
}

export default LectureTab
